/**
 * <zh> 解析 padding
 *
 * <en> parse padding
 * @param padding - <zh> padding | <en> padding
 * @returns <zh> 标准 padding | <en> standard padding
 */
export function parsePadding(padding = 0) {
    if (Array.isArray(padding)) {
        const [top = 0, right = top, bottom = top, left = right] = padding;
        return [top, right, bottom, left];
    }
    return [padding, padding, padding, padding];
}
//# sourceMappingURL=padding.js.map